import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import translator from '@Components/Utilities/Translator';
import { webSavedSearchNameCharCountLimit, webSavedSearchAuthenticatedLimit } from '@Components/Utilities/SandhillsConstants';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import WebSavedSearchItem from '@Components/WebSavedSearches/WebSavedSearchItem';
import { useWindowSize } from '@Components/Utilities/WindowSize';


const WebSavedSearchesList = (props) => {

    const [pendingSearchName, setPendingSearchName] = useState(props.PendingSearchName);
    const currentUser = useRecoilValue(atoms.currentUser);
    const windowSize = useWindowSize();

    const textboxStyles = {
        fontSize: windowSize.isMobile ? '14px' : '16px',
        marginLeft: '10px'
    };

    const buttonStyles = {
        fontWeight: '700'
    };

    const saveSearch = () => {
        props.saveCurrentSearch(pendingSearchName);
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substr(0, maxLength);
    };
    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            props.saveCurrentSearch(pendingSearchName);
        }
    };

    return (
        <>
            {props.Loading && <LoadingRing sxBox={{ 'justify-content': 'center' }} backdrop />}
            <div className='saved-searches'>
                {props.PendingSave ?
                    <div className='saved-searches__save-current-search'>
                        <h3>{translator.translate('sandhills.tradesites.mvc.savedsearchname')}</h3>
                        <TextField id="saved-search-name" variant="standard"
                            className='saved-searches__save-current-text-input'
                            placeholder={translator.translate('sandhills.tradesites.mvc.enternameforsavedsearch')}
                            label={translator.translate('sandhills.tradesites.mvc.savedsearchname')}
                            inputProps={{ style: { ...textboxStyles } }}
                            sx={{ width: '50%', 'border-bottom': 'none' }}
                            InputLabelProps={{ className: 'visually-hidden', shrink: true }}
                            value={pendingSearchName}
                            disabled={props.WebSavedSearches?.length >= webSavedSearchAuthenticatedLimit}
                            onChange={(e) => setPendingSearchName(truncateText(e.target.value, webSavedSearchNameCharCountLimit))}
                            onKeyPress={onKeyPress} />
                        {props.Message &&
                            <div>
                                <p className='error-message'>{props.Message}</p>
                                {props.WebSavedSearches?.length >= webSavedSearchAuthenticatedLimit && props.PendingSave &&
                                    <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.setPendingSave(!props.PendingSave); } }} onClick={() => props.setPendingSave(!props.PendingSave)} className='edit-link'>{translator.translate('sandhills.tradesites.mvc.editsearches')}</div>
                                }
                            </div>
                        }
                        <div style={{ 'margin-top': '25px' }}>
                            <Button className={props.WebSavedSearches?.length < webSavedSearchAuthenticatedLimit ? 'save-button' : 'save-button disabled'} variant="contained" onClick={saveSearch} sx={buttonStyles} disabled={props.WebSavedSearches?.length >= webSavedSearchAuthenticatedLimit}>{currentUser.IsAuthenticated ? translator.translate('sandhillssystem.save') : translator.translate('sandhills.tradesites.mvc.loginandsavesearch')}</Button>
                            <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.onClose(); } }} onClick={props.onClose} className='cancel-button'>{translator.translate('sandhills.cancel')}</a>
                        </div>
                    </div>
                    :
                    <>
                        {props.Message &&
                            <>
                                <p className='error-message'>{props.Message}</p>
                                {props.WebSavedSearches?.length >= webSavedSearchAuthenticatedLimit && props.PendingSave &&
                                <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); props.setPendingSave(!props.PendingSave); } }} onClick={() => props.setPendingSave(!props.PendingSave)} className='edit-link'>{translator.translate('sandhills.tradesites.mvc.editsearches')}</div>
                                }
                            </>
                        }
                        <div className='saved-searches__current-saved-searches'>
                            {props.WebSavedSearches?.length > 0 &&
                                <>
                                    {props.WebSavedSearches.map(s =>
                                        <WebSavedSearchItem updateWebSavedSearch={props.updateWebSavedSearch} removeWebSavedSearch={props.removeWebSavedSearch} {...s} setPendingSearchName={setPendingSearchName} truncateText={truncateText} />
                                    )}
                                </>
                            }
                        </div>
                    </>
                }
            </div>
        </>
    );
};

export default WebSavedSearchesList;